<script setup lang="ts">
import { ref, reactive, computed } from 'vue'
import { useRouter } from 'vue-router'
import common from '@/utils/common'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/modules/user'
import navigation from '@/layout/components/Navbar/navigation.vue'
import notice from '@/layout/components/Navbar/notice.vue'
import Cookies from 'js-cookie'
import { ElMessage } from 'element-plus'
import { changeRole } from '@/api/common'

// pinia使用
const userStore = useUserStore()
const { userInfo } = storeToRefs(userStore)

// 数据初始化
const router = useRouter()
const activeIndex = ref()
const dialogVisible = ref(false)
let logoImg = ref('')
let iframeUrl = ref('')
let webPre = ref('')

// 区分美吉、桑格
const {
  VITE_APP_MJ_KF_ORIGIN,
  VITE_APP_SG_KF_ORIGIN,
  VITE_APP_MJ_CLOUD_ORIGIN,
  VITE_APP_SG_CLOUD_ORIGIN
} = import.meta.env

let kfOrigin = ref('')
let cloudOrigin = ref('')

if (common.getWebName() === 'mj') {
  kfOrigin.value = VITE_APP_MJ_KF_ORIGIN
  cloudOrigin.value = VITE_APP_MJ_CLOUD_ORIGIN
  logoImg.value = `${cloudOrigin.value}/v2/static/images/majorbio_logo.png`
} else if (common.getWebName() === 'sg' || common.getWebName() === 'local') {
  kfOrigin.value = VITE_APP_SG_KF_ORIGIN
  cloudOrigin.value = VITE_APP_SG_CLOUD_ORIGIN
  logoImg.value = `${kfOrigin.value}/static/img/common/header/sanger_logo.png`
}

iframeUrl.value = `${kfOrigin.value}/web/ucenter/personal/account-info/change-account`
webPre.value = `${cloudOrigin.value}/page/`

const preName = computed(() => {
  let name = userInfo.value.display_name || userInfo.value.real_name
  let firstChar = ''
  if (name) {
    firstChar = name.slice(0, 1)
  }
  return firstChar
})

// 跳转项目中心
const toCenter = () => {
  // if (
  //   NODE_ENV === 'local' ||
  //   NODE_ENV === 'test' ||
  //   (NODE_ENV === 'production' && common.getWebName() === 'sg')
  // ) {
  router.push('/project-center/overview')
  // } else {
  //   let webSrc = webPre.value + 'project/overview.html'
  //   window.location.href = webSrc
  // }
}

// 退出登录
const quit = () => {
  // 退出登录清空一些缓存
  common.removeCache('vip-token')
  common.removeCache('token')
  userStore.clearVipToken()
  common.removeCache('user')
  localStorage.removeItem('extraContact')
  Cookies.remove('contractReadVisible')
  Cookies.remove('panMajorbioVisible')
  Cookies.remove('sso')
  ElMessage.success('退出成功')

  window.location.href = `${kfOrigin.value}/web/login/passport/logout`
}

// tabs切换
const handleClick = (key: number) => {
  console.log(key, typeof key)
}

// 水印
const bgImage = () => {
  if (import.meta.env.VITE_APP_ENV === 'production') {
    return '#fff' // 生产环境无背景
  } else {
    const NODE_ENV = import.meta.env.VITE_APP_ENV
    let bgImagePath = ''
    if (NODE_ENV === 'local') {
      bgImagePath = new URL(
        `@/assets/images/common/development.png`,
        import.meta.url
      ).href
    } else if (NODE_ENV === 'test') {
      bgImagePath = new URL(`@/assets/images/common/test.png`, import.meta.url)
        .href
    } else if (NODE_ENV === 'staging') {
      bgImagePath = new URL(
        `@/assets/images/common/staging.png`,
        import.meta.url
      ).href
    }
    return `#fff url(${bgImagePath}) repeat-x 0 -18px`
  }
}
// 跳转到在线客服
const toIm = () => {
  window.open(`${kfOrigin.value}/im`, '_blank')
}

// 导航跳转
const toNav = (link: string) => {
  window.location.href = link
}

// 切换角色
const changeType = async () => {
  let yptType = null
  if (userInfo.value.ypt_type === 1) {
    yptType = 2
  } else if (userInfo.value.ypt_type === 2) {
    yptType = 1
  }
  let params = {
    ypt_type: yptType,
    redirect_url: window.location.href
  }
  let res = await changeRole(params)
  let { data, code, message } = res
  if (code === 0) {
    console.log(data)

    const NODE_ENV = import.meta.env.VITE_APP_ENV
    let domain = ''
    // 区分美吉、桑格
    if (common.getWebName() === 'mj' || common.getWebName() === 'local') {
      if (NODE_ENV === 'production') {
        // 生产
        domain = 'majorbio.com'
      } else if (NODE_ENV === 'staging') {
        // 预发
        domain = 'major.com'
      } else if (NODE_ENV === 'flex') {
        // 灵活
        domain = 'pngs.com'
      } else if (NODE_ENV === 'test') {
        // 测试
        domain = 'mj.com'
      } else if (NODE_ENV === 'local') {
        // 本地
        domain = 'localhost'
      }
    } else if (common.getWebName() === 'sg') {
      if (NODE_ENV === 'production') {
        // 生产
        domain = 'i-sanger.com'
      } else if (NODE_ENV === 'staging') {
        // 预发
        domain = 'sanger.com'
      } else if (NODE_ENV === 'flex') {
        // 灵活
        domain = 'pngs.com'
      } else if (NODE_ENV === 'test') {
        // 测试
        domain = 'sg.com'
      } else if (NODE_ENV === 'local') {
        // 本地
        domain = 'localhost'
      }
    }

    Cookies.set('sso', data.sso, { domain })
    window.location.reload()
  } else {
    ElMessage({
      message: message,
      type: 'error'
    })
  }
  console.log('切换用户')
}

const NODE_ENV = import.meta.env.VITE_APP_ENV
</script>

<template>
  <div
    class="navbar flex justify-between items-center"
    :style="{ background: bgImage() }"
  >
    <!-- 左侧 -->
    <div class="nav-l flex items-center flex-1">
      <img
        @click="toNav(`${kfOrigin}/web/www/index`)"
        v-if="common.getWebName() === 'mj'"
        class="logo"
        :src="logoImg"
      />
      <img
        @click="toNav(`${kfOrigin}/web/www/index`)"
        v-if="common.getWebName() === 'sg' || common.getWebName() === 'local'"
        class="sg-logo"
        :src="logoImg"
      />
      <navigation />
    </div>
    <!-- 右侧 -->
    <div class="nav-r flex items-center">
      <notice />

      <span
        v-if="common.getWebName() === 'sg' || common.getWebName() === 'local'"
        class="link"
        style="
          width: 100px;
          border-radius: 50px;
          height: 32px;
          line-height: 32px;
          margin-left: 80px;
        "
        link
        @click="toCenter"
        >项目中心</span
      >
      <span
        v-if="common.getWebName() === 'mj'"
        class="link"
        link
        @click="toCenter"
        >项目中心</span
      >
      <el-popover
        popper-class="user-popper"
        placement="bottom"
        :width="220"
        trigger="hover"
      >
        <template #reference>
          <span class="mj-theme-bg pointer avatar">{{ preName }}</span>
        </template>
        <template #default>
          <div class="user">
            <span>{{ preName }}</span>
            <div>
              <p>{{ userInfo.display_name || userInfo.nick_name }}</p>
              <p v-if="userInfo.is_contract_pay">
                合同客户<i class="member-type active"></i>
              </p>
              <p v-else>非合同客户<i class="member-type"></i></p>
            </div>
          </div>
          <div class="date">当前会员有效期：{{ userInfo.end_time }}</div>
          <div>
            <ul>
              <li
                class="mj-theme-ft-hover"
                @click="
                  common.openUrl('kf', 'ucenter/personal/account-info/index')
                "
              >
                <i class="icon-person"></i>个人中心
              </li>
              <li
                class="mj-theme-ft-hover"
                @click="
                  common.openUrl('kf', 'ucenter/learn/my-lesson/learning-index')
                "
              >
                <i class="icon-learn"></i>学习中心
              </li>
              <li
                class="mj-theme-ft-hover"
                @click="common.openUrl('kf', 'ucenter/order/my-order/index')"
              >
                <i class="icon-order"></i>订单中心
              </li>
            </ul>
            <ul v-if="userInfo.im_role && userInfo.im_role > 0">
              <!-- <ul> -->
              <li class="mj-theme-ft-hover" @click="toIm">
                <i class="icon-service"></i>在线客服
              </li>
            </ul>
          </div>

          <div
            v-if="common.getWebName() === 'mj'"
            class="card pointer"
            @click="common.openUrl('kf', 'www/vip/index')"
          >
            <p>开通会员 ，享受更多权益</p>
            <span>查看权益</span>
          </div>
          <div class="popper-footer">
            <span class="mj-theme-ft-hover mb10" @click="dialogVisible = true"
              ><i class="icon-account"></i>切换账号</span
            >
            <span
              class="mj-theme-ft-hover mb10"
              v-if="userInfo.can_change_ypt_type"
              @click="changeType"
              ><i class="icon-role"></i
              >{{
                userInfo.ypt_type === 1
                  ? '切换为客户'
                  : userInfo.ypt_type === 2
                  ? '切换为生信'
                  : ''
              }}</span
            >
            <span class="mj-theme-ft-hover mb10" @click="quit"
              ><i class="icon-quit"></i>退出登录</span
            >
          </div>
        </template>
      </el-popover>
    </div>

    <!-- 切换账号（模态弹窗） -->
    <el-dialog
      draggable
      v-model="dialogVisible"
      align-center
      width="450"
      title="请选择账号"
      :before-close="() => (dialogVisible = false)"
      class="iframe-dialog"
    >
      <iframe :src="iframeUrl" frameborder="0"></iframe>
    </el-dialog>
  </div>
</template>

<style lang="scss">
@import '@/styles/layout/navbar.scss';
</style>
